<template>
  <OurConfirmModal
    v-model="isShownModal"
    :title="$t('title.users.delete')"
    :action-button-text="$t('button.remove')"
    color="gray"
    @actionConfirmed="onClickDeleteButton"
  >
    <OurTextBlock v-html="$t('page.users.removeConfirm', { name: fullName })" />
  </OurConfirmModal>
</template>

<script>
import apolloMixin from "@/mixins/apollo.mixin";

export default {
  name: "DeleteModal",

  mixins: [apolloMixin],

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    userId: {
      type: String,
      default: "",
    },

    fullName: {
      type: String,
      default: "",
    },
    mutation: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
    },
  },

  computed: {
    isShownModal: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },

  methods: {
    closeModal() {
      this.isShownModal = false;
    },

    onClickCloseButton() {
      this.closeModal();
    },

    async onClickDeleteButton() {
      await this.$post(this.mutation, { userId: this.userId }, { delaySuccessNotify: true });

      this.$emit("deleteUser");
    },
  },
};
</script>
